import React, { Component } from "react";
import HeadBar from "./common/HeadBar";
import FootBar from "./common/FootBar";
import "../style/cart.scss";
import no_cart from "../image/no-cart.png";
import { routePage } from "../utils/routePage";
import CheckIcon from "../icon/CheckIcon";
import CloseIcon from "../icon/Close";
import CircleAdd from "../icon/CIrcleAdd";
import CircleSub from "../icon/CircleSub";
import * as PostMessageAPI from "../apis/PostMessageAPI";
import { BASE_URL } from "../constants/ApiEndpointConstants";

class Cart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cartList: JSON.parse(localStorage.getItem("cartList")) || [],
      cartTotal: JSON.parse(localStorage.getItem("cartTotal")) || 0,
    };
    this.handleSub = this.handleSub.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  HeadBarRef = React.createRef();

  componentDidMount() {
    window.scrollTo(0, 0);
    PostMessageAPI.postMessage(BASE_URL + `[Cart Page]`);
  }

  formatNumber(n) {
    return n < 10 ? `0${n}` : `${n}`;
  }

  handleSub(num, index) {
    let { cartList } = this.state;
    if (num > 1) {
      cartList[index].num -= 1;
      cartList.map((item) => ({ ...item, total: item.num * item.price }));
      let cartTotal = cartList.reduce(
        (sum, item) => sum + item.num * item.price,
        0
      );
      localStorage.setItem("cartList", JSON.stringify(cartList));
      localStorage.setItem("cartTotal", JSON.stringify(cartTotal));
      this.setState({ cartList, cartTotal }, () => {
        if (this.HeadBarRef) {
          this.HeadBarRef.current.setState({ num: num + 1 });
        }
      });
    }
  }

  handleAdd(num, index) {
    let { cartList } = this.state;
    cartList[index].num += 1;
    cartList.map((item) => ({ ...item, total: item.num * item.price }));
    let cartTotal = cartList.reduce(
      (sum, item) => sum + item.num * item.price,
      0
    );
    let cartNum = cartList.reduce((sum, item) => sum + item.num, 0);
    localStorage.setItem("cartList", JSON.stringify(cartList));
    localStorage.setItem("cartTotal", JSON.stringify(cartTotal));
    localStorage.setItem("cartNum", JSON.stringify(cartNum));
    this.setState({ cartList, cartTotal }, () => {
      if (this.HeadBarRef) {
        this.HeadBarRef.current.setState({ num: cartNum });
      }
    });
  }

  removeItem(index) {
    let { cartList } = this.state;
    cartList.splice(index, 1);
    let cartTotal = cartList.reduce(
      (sum, item) => sum + item.num * item.price,
      0
    );
    let cartNum = cartList.reduce((sum, item) => sum + item.num, 0);
    localStorage.setItem("cartList", JSON.stringify(cartList));
    localStorage.setItem("cartTotal", JSON.stringify(cartTotal));
    localStorage.setItem("cartNum", JSON.stringify(cartNum));
    this.setState({ cartList, cartTotal }, () => {
      if (this.HeadBarRef) {
        this.HeadBarRef.current.setState({ num: cartNum });
      }
    });
  }

  render() {
    let { cartList, cartTotal } = this.state;
    let { history, location } = this.props;
    return (
      <React.Fragment>
        <HeadBar {...this.props} ref={this.HeadBarRef} />
        {cartList.length > 0 && (
          <div className="mask-btn">
            <div className="total-box">
              <div className="left">결제금액</div>
              <div className="right">
                <div className="tip">
                  상품 {cartTotal?.toLocaleString("ko-KR")}원 -{" "}
                  <span>할인 0 원</span> + 배송비 0 원
                </div>
                <div className="price">
                  {" "}
                  {cartTotal?.toLocaleString("ko-KR")}원
                </div>
              </div>
            </div>
            <div
              className="check-btn"
              onClick={() => routePage(history, location, "/Customer")}
            >
              선택 상품 주문하기
            </div>
          </div>
        )}
        <div className="cart-page">
          {cartList.length > 0 ? (
            <React.Fragment>
              <div className="has-product">
                <div className="product-box">
                  <div className="title">
                    <div className="left">
                      <CheckIcon size={20} className="check" />
                      상온 & 실온
                    </div>
                  </div>
                  {cartList.map((item, index) => {
                    return (
                      <div className="product-li" key={index}>
                        <div className="li-title">
                          <div className="left">
                            <CheckIcon size={14} className="check" />
                            피부 에버콜라겐
                          </div>
                          <CloseIcon
                            size={20}
                            onClick={() => this.removeItem(index)}
                          />
                        </div>
                        <div className="li-img">
                          <div className="left">
                            <div className="title">{item.title}</div>
                            <div className="sku">{item?.sku}</div>
                          </div>
                          <div className="img">
                            <img src={item.img} alt="" />
                          </div>
                        </div>
                        <div className="li-number">
                          <div className="left"></div>
                          <div className="number-box">
                            <CircleSub
                              size={20}
                              color="#999"
                              className="circleSub"
                              onClick={() => this.handleSub(item.num, index)}
                            />
                            <div className="num">
                              {this.formatNumber(item.num)}
                            </div>
                            <CircleAdd
                              size={20}
                              color="#999"
                              className="circleAdd"
                              onClick={() => this.handleAdd(item.num, index)}
                            />
                          </div>
                        </div>
                        <div className="total-row">
                          <div className="li-total1">
                            <div className="left">상품금액</div>
                            <div className="price">
                              {item?.total?.toLocaleString("ko-KR")}원
                            </div>
                          </div>
                          <div className="li-total1">
                            <div className="left">할인금액</div>
                            <div className="price">-0원</div>
                          </div>
                          <div className="li-total">
                            <div className="left">주문금액</div>
                            <div className="price">
                              {item?.total?.toLocaleString("ko-KR")}원
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="total-box">
                  <div className="total-title">결제예정금액</div>
                  <div className="total-li">
                    <div className="left">총 상품금액</div>
                    <div className="price">
                      {cartTotal?.toLocaleString("ko-KR")} 원
                    </div>
                  </div>
                  <div className="total-li">
                    <div className="left">총 할인금액</div>
                    <div className="price">0 원</div>
                  </div>
                  <div className="total-li">
                    <div className="left">배송비</div>
                    <div className="price">0 원</div>
                  </div>
                  <div className="total-bottom">
                    <div className="left">총 결제 예정 금액</div>
                    <div className="price">
                      = {cartTotal?.toLocaleString("ko-KR")} 원
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ) : (
            <div className="no-product">
              <div className="img">
                <img src={no_cart} alt="" />
              </div>
              <p className="no-title">장바구니에 담긴 상품이 없습니다.</p>
              <div
                className="continue-btn"
                onClick={() => routePage(history, location, "/Model")}
              >
                계속하기
              </div>
            </div>
          )}
        </div>
        <FootBar {...this.props} />
      </React.Fragment>
    );
  }
}

export default Cart;
